<div class="card">
  <div class="card-header">
    <h2 class="card-title">Gerenciamento de Compartilhamentos</h2>
  </div>

  <div class="card-body">
    <!-- SEÇÃO DE FILTROS -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon>filter_list</mat-icon>
          Filtros de Busca
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="filters-content">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Filtrar por Proprietário</mat-label>
          <input matInput [(ngModel)]="filterOwner" placeholder="Digite o email do proprietário">
          <mat-icon matSuffix>person</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Filtrar por Empresa</mat-label>
          <input matInput [(ngModel)]="filterCompany" placeholder="Digite o nome da empresa">
          <mat-icon matSuffix>business</mat-icon>
        </mat-form-field>

        <mat-checkbox [(ngModel)]="showOnlyActive">
          Mostrar apenas ativos
        </mat-checkbox>

        <div class="filter-actions">
          <button mat-raised-button color="primary" (click)="applyFilters()" class="btn btn-primary">
            <mat-icon>search</mat-icon>
            Aplicar Filtros
          </button>
          <button mat-stroked-button (click)="clearFilters()" class="btn btn-ghost">
            <mat-icon>clear</mat-icon>
            Limpar
          </button>
        </div>
      </div>
    </mat-expansion-panel>

    <!-- TABELA DE COMPARTILHAMENTOS -->
    <div class="table-container">
      <h3 class="title-section">Lista de Compartilhamentos</h3>
      
      <table mat-table [dataSource]="documentSharing" class="sharing-table">
        <!-- Coluna ID -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>ID</th>
          <td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container>

        <!-- Coluna Email do Proprietário -->
        <ng-container matColumnDef="ownerPFEmail">
          <th mat-header-cell *matHeaderCellDef>Proprietário</th>
          <td mat-cell *matCellDef="let element">
            <div class="owner-cell">
              <mat-icon class="cell-icon">person</mat-icon>
              <span>{{ element.ownerDocumentsCpfCnpj }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Coluna Empresa Concedida -->
        <ng-container matColumnDef="grantedPJId">
          <th mat-header-cell *matHeaderCellDef>Empresa</th>
          <td mat-cell *matCellDef="let element">
            <div class="company-cell">
              <mat-icon class="cell-icon">business</mat-icon>
              <span>{{element.grantedCompanyCnpj}}</span>
            </div>
          </td>
        </ng-container>

        <!-- Coluna Data de Concessão -->
        <ng-container matColumnDef="grantedDate">
          <th mat-header-cell *matHeaderCellDef>Concedido em</th>
          <td mat-cell *matCellDef="let element">
            {{ element.grantedDate | date:'dd/MM/yyyy HH:mm' }}
          </td>
        </ng-container>

        <!-- Coluna Data de Revogação -->
        <ng-container matColumnDef="revokedDate">
          <th mat-header-cell *matHeaderCellDef>Revogado em</th>
          <td mat-cell *matCellDef="let element">
            {{ element.revokedDate ? (element.revokedDate | date:'dd/MM/yyyy HH:mm') : '' }}
          </td>
        </ng-container>

        <!-- Coluna Status -->
        <ng-container matColumnDef="active">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">
            <span class="badge" [ngClass]="element.active ? 'badge-success' : 'badge-error'">
              {{ element.active ? 'Ativo' : 'Revogado' }}
            </span>
          </td>
        </ng-container>

        <!-- Coluna Ações -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Ações</th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button [matMenuTriggerFor]="menu" color="primary">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="viewDetails(element)">
                <mat-icon>visibility</mat-icon>
                <span>Ver Detalhes</span>
              </button>
              <button mat-menu-item (click)="revokeAccess(element.id)" [disabled]="!element.active">
                <mat-icon>block</mat-icon>
                <span>Revogar Acesso</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsAttachment"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsAttachment;"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumnsAttachment.length">
            Nenhum compartilhamento encontrado
          </td>
        </tr>
      </table>

      <div class="table-footer">
        <small>Total de compartilhamentos: {{ documentSharing.length }}</small>
      </div>
    </div>
  </div>
</div>